<template>
  <div class="container-fluid mycontainer-fluid body-wrapper">
    <div class="row myrow row-wrapper"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Home",
  computed: {
    ...mapGetters(["isAuthenticated", "currentUser"])
  },
  created() {
    if (this.isAuthenticated) {
      if (
        this.currentUser &&
        (this.currentUser.ACTIVE_ROLE == 36 ||
          this.currentUser.ACTIVE_ROLE == 37)
      ) {
        this.$router.push({ name: "Conference" });
      } else {
        this.$router.push({ name: "Projects" });
      }
    }
  }
};
</script>
